import React from 'react';
import {NEW_CYBERSOURCE_PAYMENT_FORM} from '../../../consts';
import ControledSelect from '../../atoms/ControledSelect';
import {pushAnalyticsEvent} from '../../organisms/Analytics';

export default function ExpirySelectField({
    field, form, onChange, ...restProps
}) {
    const handleChange = event => {
        if (onChange) {
            return onChange(event);
        }

        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: NEW_CYBERSOURCE_PAYMENT_FORM,
            formField: field.name
        });

        return form.setFieldValue(field.name, event.target.value);
    };

    return (
        <ControledSelect
            {...restProps}
            {...field}
            onChange={handleChange}
        />
    );
}
